__webpack_require__.p = "/getting-started-help-articles/account-setup/";